import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/style.css";
import { FaMoon, FaSun } from "react-icons/fa";
import { MdLocalMovies } from "react-icons/md";

const Header = () => {
    const location = useLocation();
    const isPlayerPage = location.pathname.includes("/player");
    const currentShow = JSON.parse(localStorage.getItem("currentShow") || "{}");
    const { name, season } = currentShow;

    const setTheme = (theme) => {
        document.body.classList.remove("light-theme", "dark-theme");
        document.body.classList.add(theme);
        localStorage.setItem("theme", theme);
    };

    const toggleTheme = () => {
        const currentTheme = document.body.classList.contains("dark-theme") ? "dark-theme" : "light-theme";
        const newTheme = currentTheme === "dark-theme" ? "light-theme" : "dark-theme";
        setTheme(newTheme);
    };

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme");
        if (savedTheme) {
            setTheme(savedTheme);
        } else {
            const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
            setTheme(systemPrefersDark ? "dark-theme" : "light-theme");
        }
    }, []);

    return (
        <header className="header">
            <div className="header-group">
                <Link to="/" className="site-title">
                    <MdLocalMovies style={{ marginBottom: "-5px", marginRight: "10px" }} /> HARD SERIES
                </Link>
                <p className="slogan">и никакой рекламы в плеере!</p>

                <div className="header-actions">
                    <button className="theme-toggle" onClick={toggleTheme}>
                        <FaSun className="icon sun-icon" />
                        <FaMoon className="icon moon-icon" />
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
